module.exports = __webpack_public_path__ + "files/618aae3fe5150ef3d2c7250deb6b3b98.png";